import { logOutSuccess } from '@techstyle/react-accounts';

const resetRequestEvents = ({ reset }) => {
  const resetRequest = reset();
  return { [logOutSuccess]: resetRequest };
};

export default resetRequestEvents;
